// extracted by mini-css-extract-plugin
export var cell = "_5s-4";
export var headerCell = "_5s-2";
export var rowHeader = "_5s-3";
export var table = "_5s-1";
export var tableContainer = "_5s-0";